import React from 'react';
import { NavLink, Link } from 'react-router-dom';

const playStoreUrl = "https://play.google.com/store/apps/details?id=com.blurr.voice";

function Navbar() {

    return (
        <nav className="sticky-nav">
            {/* Logo — absolute top-left corner of screen */}
            <Link 
                to="/" 
                className="nav-brand" 
                id="nav-logo" 
                style={{ display: 'flex', alignItems: 'center' }}
                title="Back to Home"
            >
                <img 
                    src="/panda.png" 
                    alt="Panda Logo" 
                    style={{ height: '50px', width: 'auto', objectFit: 'contain' }} 
                />
            </Link>

            {/* Nav links — absolute top-right corner */}
            <div className="nav-right" id="nav-links-right">
                {/* Fixed the URL: changed /team to /about */}
                <NavLink to="/blog" className="nav-item">Blog</NavLink>
                <NavLink to="/changelog" className="nav-item">Changelog</NavLink>
                <NavLink to="/about" className="nav-item">About</NavLink>
                <NavLink to="/privacy-policy" className="nav-item">Privacy</NavLink>
                
                <a
                    href={playStoreUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="clip-btn clip-btn-accent"
                    id="nav-download-btn"
                >
                    GET ON PLAY STORE
                </a>
            </div>
        </nav>
    );
}

export default Navbar;